import coverUploadPlaceholder from "./coverUploadPlaceholder";
import formInputsCustom from "./formInputsCustom";
import formInputsPrimary from "./formInputsPrimary";
import formInputsSecondary from "./formInputsSecondary";
import section from "./section";
import sectionLabel from "./sectionLabel";
import shared from "./shared";
import select from "./select";

export default `
  ${coverUploadPlaceholder}
  ${formInputsCustom}
  ${formInputsPrimary}
  ${formInputsSecondary}
  ${section}
  ${sectionLabel}
  ${shared}
  ${select}
`;
